import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";

import React, { useEffect, useState } from "react";
import { getUserData } from "../../utils/localStorage";
import {
  getStoreRiderInfo,
  getStoreTimeSlot,
  postPickupRequest,
  updatePickupRequest,
} from "../../services/StoreRiderInfo/StoreRiderInfo";


const { innerWidth: width, innerHeight: height } = window;

const PickupRequest = ({
  pickupRequestModalVisible,
  setPickupRequestModalVisible,
  status,
  text,
  storeId,
  storeCustomerId,
  editMode,
  sendResponse,
  pickupDeliveryRequestData,
}) => {
  const { userProfileRole } = getUserData();
  const {
    storeCustomerId: pickupDeliveryStoreCustomerId,
    storeUserId,
    pickupDeliveryTimeSlot,
    pickupOn,
    riderName,
    pickupDeliveryStatus,
  } = pickupDeliveryRequestData;

  let initialDate = new Date();
  let editModeDate = initialDate;
  if (editMode) {
    let pickupOnDate = new Date(pickupOn).getTime();
    let today = new Date().getTime();
    let msDay = 24 * 60 * 60 * 1000; // milliseconds per day
    let days = Math.floor((today - pickupOnDate) / msDay);

    if (days < 0) {
      editModeDate = pickupOn;
    }
  }
  const [riderInfo, setRiderInfo] = useState([]);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(editMode ? pickupDeliveryTimeSlot : "");
  // const [assignRiderValue, setAssignRiderValue] = useState(
  //   editMode ? {name: riderName, code: storeUserId} : ""
  // );
  const [assignRiderValue, setAssignRiderValue] = useState("");

  const [timeSlotData, setTimeSlotData] = useState([]);
  const [date, setDate] = useState(new Date(editModeDate));
  const [selectedCity, setSelectedCity] = useState(null);

  const [timeSlotError, setTimeSlotError] = useState("");
  const [assignRiderError, setAssignRiderError] = useState("");
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3); // Add 3 months to current date


  const fetchStoreRiderInfo = () => {
    getStoreRiderInfo(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const filterRes = Res.map((item) => ({
            name: item.firstName + item.lastName,
            code: item.id,
          }));
          setRiderInfo(filterRes);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchStoreRiderTimeSlot = (currentTime) => {
    getStoreTimeSlot(storeId, currentTime)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setTimeSlotData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreRiderInfo();
    const currentTime = new Date();
    if (currentTime >= new Date()) {
      fetchStoreRiderTimeSlot(currentTime.getHours());
    } else {
      setSelectedTimeSlot([]);
    }
  }, []);

  const handleModalClose = () => {
    setPickupRequestModalVisible(false);
    setTimeSlotData([]);
    setRiderInfo([]);
    setSelectedTimeSlot("");
    setAssignRiderValue("");
  };

  const handleDateChange = (selectedDate) => {
    if (selectedDate !== undefined) {
      // Prevent selection of past dates
      
      // if (selectedDate >= new Date()) {
        const utcDate = new Date(
          Date.UTC(
            selectedDate.getFullYear(),
            selectedDate.getMonth(),
            selectedDate.getDate()
          )
        );
        setDate(utcDate);
        if (utcDate >= new Date()) {
          fetchStoreRiderTimeSlot(utcDate.getHours());
        } else {
          setSelectedTimeSlot([]);
        }
      // }
    }
  };

  const onNextButtonPress = () => {
    if (selectedTimeSlot.length <= 0) {
      setTimeSlotError("Please Chose Correct Pickup Date And Time");
    } else if (assignRiderValue === "") {
      setAssignRiderError("Please Select any Rider");
    } else {
    const currentDateTime = date.toISOString();
      
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);
        if (editMode) {
          // Logic for updating a pickup request
          const updatedPickupRequest = {
            id: pickupDeliveryRequestData.id,
            storeId: storeId,
            storeCustomerId: pickupDeliveryStoreCustomerId,
            storeUserId: assignRiderValue.code,
            pickupTimeSlot: selectedTimeSlot,
            // pickupOn: new Date(date).toISOString(),
            pickupOn: currentDateTime, 
            pickupStatus: pickupDeliveryStatus,
            source:  userProfileRole === "BY_ADMIN" ? "admin" : "store",
          };

          console.log("updatedPickupRequest", updatedPickupRequest)

          // Call the service function for updating pickup request
          updatePickupRequest(
            pickupDeliveryStoreCustomerId,
            storeId,
            updatedPickupRequest
          )
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  sendResponse({
                    message,
                    status,
                    modalFun: false,
                  });
                  // Reset state variables
                  setTimeSlotData([]);
                  setRiderInfo([]);
                  setSelectedTimeSlot("");
                  setAssignRiderValue("");
                  setIsSubmitButtonPressed(false);
                  setPickupRequestModalVisible(false);
                }
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        } else {
          // Logic for creating a new pickup request
          const newPickupRequest = {
            storeId: storeId,
            storeCustomerId: storeCustomerId,
            storeUserId: assignRiderValue.code,
            pickupTimeSlot: selectedTimeSlot,
            // pickupOn: new Date(date).toISOString(),
            pickupOn: currentDateTime,
            source: userProfileRole === "BY_ADMIN" ? "admin" : "store",
          };
          // Call the service function for creating pickup request
          postPickupRequest(storeCustomerId, storeId, newPickupRequest)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  sendResponse({ message, status, modalFun: false });
                  // Reset state variables
                  setTimeSlotData([]);
                  setRiderInfo([]);
                  setSelectedTimeSlot("");
                  setAssignRiderValue("");
                  setIsSubmitButtonPressed(false);
                  setPickupRequestModalVisible(false);
                }
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      }
    }
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={pickupRequestModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!pickupRequestModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: height < 600 ? 50 : 60,
                  width: height < 600 ? 50 : 60,
                  // alignSelf: 'center',
                }}
                src={
                  "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Pickup_Request.gif"
                }
              />

              <p className=" text-3xl text-primary-50 font-semibold">
                Pickup Request
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div className="flex-auto mx-4">
              <p className="font-bold block mb-2 ml-2">Pickup Date</p>
              <Calendar
                id="buttondisplay"
                value={date}
                onChange={(e) => handleDateChange(e.value)}
                showIcon
                minDate={new Date()}
                maxDate={maximumDate}
                className="w-full  bg-white-alpha-20 border-round-lg p-1 text-md text-primary-50"
                dateFormat="dd/mm/yy"
              />
            </div>

            <div className="inline-flex flex-column gap-2 mx-4">
              <Dropdown
                value={selectedTimeSlot}
                onChange={(e) => setSelectedTimeSlot(e.value)}
                options={timeSlotData}
                placeholder="Select Pickup Time"
                className="w-full  bg-white-alpha-20 border-round-lg text-xl text-primary-50"
              />
            </div>
            {timeSlotError && (
              <div className="inline-flex flex-column gap-2 mx-4">
                <p
                  className="font-normal text-lg block"
                  style={{ color: "red" }}
                >
                  {timeSlotError}
                </p>
              </div>
            )}
            {userProfileRole === "BY_STORE" ||
            userProfileRole === "BY_ADMIN" ||
            userProfileRole === "BY_SUB_ADMIN_USER" ? (
              <div className="inline-flex flex-column gap-2 mx-4">
                <Dropdown
                  value={assignRiderValue}
                  onChange={(e) => setAssignRiderValue(e.value)}
                  options={riderInfo}
                  optionLabel="name"
                  placeholder="Assign Rider"
                  className="w-full  bg-white-alpha-20 border-round-lg text-xl text-primary-50"
                />
              </div>
            ) : (
              <div className="inline-flex flex-column gap-2 mx-4">
                <p className="text-primary-50 font-semibold">Rider Info</p>
                <InputText
                  value={riderName}
                  disabled
                  id="username"
                  label="Username"
                  className="bg-white-alpha-20 border-round-lg p-3 text-xl text-primary-50"
                ></InputText>
              </div>
            )}
            {assignRiderValue === "" && assignRiderError && (
              <div className="flex-auto ml-4">
                <p
                  className="font-normal text-lg block mb-2 "
                  style={{ color: "red" }}
                >
                  {assignRiderError}
                </p>
              </div>
            )}

            <Button
              disabled={isSubmitButtonPressed}
              onClick={onNextButtonPress}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-xl font-semibold flex justify-content-center">
                Submit Request
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default PickupRequest;
